import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { ViewportController } from '../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { EnumService } from '../../../../app.common/modules/common/services/enum.service';
import { LanguageService } from '../../../../app.common/modules/common/services/languge.service';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { IRetailerType } from '../../account/model/iUser';
import { StoreTapAndGo } from '../../core';
import { IRetailerRootScope } from '../../core/models';
import { EShoppingScanMethod, IStickerItem, IStoreTapAndGo, IStoreTapAndGoListItem } from '../models';
import { OrderSettingsService } from '../order-settings.service';

const STICKER_PATTERN = '[A-Z]{1}\\d{12}$';

class OrderSettingsLocations extends ViewportController implements ng.IController {
    public static $inject = ['$scope', 'orderSettingsService', 'notificationService', '$translate', 'enumService', '$timeout', 'popupService', '$rootScope', 'languageService'];
    public checkInStickersTitle: string = '';
    public checkOutStickersTitle: string = '';
    public monitorState: any = null;
    public waiting = false;
    public places: IStoreTapAndGoListItem[] = null;
    public isPlacesAny = null;
    public scanAction = this.enumService.ProductScanAction;
    public edit = {
        isOpenEdit: false,
        newCheckInCode: null,
        newCheckOutCode: null,

        newCheckInNfcStickers: [] as IStickerItem[],
        newCheckOutNfcStickers: [] as IStickerItem[],

        isGrocery: true,

        model: {
            DefaultProductScanAction: this.scanAction.AddToCart,
            ShoppingScanMethod: EShoppingScanMethod.BARCODE,
            PinCode: null,
            CheckInNfcStickerCodes: [],
            CheckOutNfcStickerCodes: [],
            CheckInNfcStickers: [],
            CheckOutNfcStickers: [],
            BagCheckSettings: null,
            ShoppingFlows: {
                JispGoOrPreOrder: {
                    Available: false,
                    Enabled: false
                },
                InStore: {
                    Available: false,
                    Enabled: false
                },
                ClickCollect: {
                    Available: false,
                    Enabled: false
                },
                Delivery: {
                    Available: false,
                    Enabled: false
                }
            },
            PayNowEnabled: null,
            CollectWithoutPincode: null,
            MonitorKey: null,
            FoodMonitor: null,
            HideMonitor: null,
            PayOutsideJispEnabled: null,
            CarrierBagEnabled: false
        } as IStoreTapAndGo,

        error: {
            defaultProductScanAction: null,
            checkInNfcStickerCodes: null,
            checkOutNfcStickerCodes: null,
            checkInNfcStickers: null,
            checkOutNfcStickers: null,
            bagCheckSettingsChance: null,
            clean: () => {
                const i = this.edit.error;
                i.defaultProductScanAction = null;
                i.checkInNfcStickers = null;
                i.checkOutNfcStickers = null;
                i.bagCheckSettingsChance = null;
            },
            isEmpty: () => {
                const i = this.edit.error;
                return _.isEmpty(i.defaultProductScanAction) &&
                    _.isEmpty(i.checkInNfcStickers) &&
                    _.isEmpty(i.checkOutNfcStickers) &&
                    _.isEmpty(i.bagCheckSettingsChance);
            }
        },
        setModel: (place?: IStoreTapAndGoListItem) => {
            const editModel = this.edit.model;
            editModel.DefaultProductScanAction = place ? place.DefaultProductScanAction : this.defaultScanAction as StoreTapAndGo.DefaultProductScanActionEnum;
            editModel.PinCode = place ? place.PinCode : null;
            editModel.PayNowEnabled = place ? place.PayNowEnabled : null;
            editModel.CollectWithoutPincode = place ? place.CollectWithoutPincode : null;
            editModel.CarrierBagEnabled = place ? place.CarrierBagEnabled : this.edit.model.CarrierBagEnabled;
            editModel.ShoppingFlows = place && place.ShoppingFlows ? {...place.ShoppingFlows} : editModel.ShoppingFlows;
            this.edit.newCheckInNfcStickers = place && _.any(place.CheckInNfcStickers) ?
                place.CheckInNfcStickers.map((item) => this.getStickerItem(item)) : [this.getStickerItem()];

            this.edit.newCheckOutNfcStickers = place && _.any(place.CheckOutNfcStickers) ?
                place.CheckOutNfcStickers.map((item) => this.getStickerItem(item)) : [this.getStickerItem()];

            this.defaultScanAction = this.$rootScope.userData.retailerType === IRetailerType.LIGHT ? this.scanAction.AddToCart : this.scanAction.ShowDetails;

            const flows = place ? place.ShoppingFlows : null;

            if (place) {
                if (place.ShoppingScanMethod) {
                    editModel.ShoppingScanMethod =  place.ShoppingScanMethod;
                } else {
                    editModel.ShoppingScanMethod = flows.InStore.Enabled ? EShoppingScanMethod.NFC : EShoppingScanMethod.BARCODE;
                }
            } else {
                editModel.ShoppingScanMethod = EShoppingScanMethod.BARCODE;
            }

            if (flows && !flows.JispGoOrPreOrder.Enabled) {
                this.edit.isGrocery = false;

                if (!editModel.DefaultProductScanAction) {
                    editModel.DefaultProductScanAction = this.scanAction.ShowDetails as StoreTapAndGo.DefaultProductScanActionEnum;
                }

            } else {
                this.edit.isGrocery = true;

                if (!editModel.DefaultProductScanAction) {
                    editModel.DefaultProductScanAction = this.scanAction.AddToCart as StoreTapAndGo.DefaultProductScanActionEnum;
                }
            }
            editModel.BagCheckSettings = {
                Enabled: place ? place.RandomCheckEnabled : false,
                Chance: place ? place.RandomCheckChance : null,
                DailyLimit: place ? place.RandomCheckDayLimit : null
            };
            editModel.FoodMonitor = place ? place.FoodMonitor : null;
            editModel.MonitorKey = place ? place.MonitorKey : null;
            editModel.HideMonitor = place ? place.HideMonitor : null;
            editModel.PayOutsideJispEnabled = place ? place.PayOutsideJispEnabled : null;
            this.edit.error.clean();
        },
        isEmptyStickersList: (stickers: IStickerItem[]) => {
            return stickers && stickers.length > 0;
        },
        refreshScanAction: () => {
            const i = this.edit.model;
            const stickers = _.filter(this.edit.newCheckOutNfcStickers, (item) => !_.isEmpty(item.Code));
            if (_.isEmpty(stickers)) {
                this.edit.isGrocery = false;
                if (i.DefaultProductScanAction === this.scanAction.AddToCart) {
                    i.DefaultProductScanAction = this.scanAction.ShowDetails as StoreTapAndGo.DefaultProductScanActionEnum;
                }
            } else {
                this.edit.isGrocery = true;

                if (i.DefaultProductScanAction === this.scanAction.FlickeringCards) {
                    i.DefaultProductScanAction = this.scanAction.AddToCart as StoreTapAndGo.DefaultProductScanActionEnum;
                }
            }
        }
    };
    public jispGoAndInStoreTooltip = this.$translate.instant('jisp_go_and_in_store_message');
    public tapTapTooltip = this.$translate.instant('tap_tap_tooltip');
    public bagFee: string;

    private maxLength = 64;
    private hideMonitorStatuses: Map<number, boolean> = new Map<number, boolean>();
    private defaultScanAction = this.scanAction.ShowDetails;

    constructor(
        private $scope: ng.IScope,
        private orderSettingsService: OrderSettingsService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private enumService: EnumService,
        private $timeout: ng.ITimeoutService,
        private popupService: PopupService,
        private $rootScope: IRetailerRootScope,
        private languageService: LanguageService
    ) {
        super($scope);
    }

    public async $onInit() {
        const countryID =  this.$rootScope.userData.countryID;
        const langSettings = this.languageService.getLangSettingsOrDefault(countryID);

        // uk or ireland
        if (countryID === 1 || countryID === 4) {
            const fracSign = langSettings.currencyFracSign;
            this.bagFee = '20' + fracSign;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.getPlaces();
            this.setCheckInAndCheckOutTitles();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public placeEdit(place: IStoreTapAndGoListItem) {
        place.isOpenEdit = true;
        this.edit.isOpenEdit = true;
        this.edit.newCheckInCode = null;
        this.edit.newCheckOutCode = null;
        this.edit.setModel(place);
    }

    public cancelEdit(place: IStoreTapAndGoListItem) {
        place.isOpenEdit = false;
        this.edit.isOpenEdit = false;
        this.edit.setModel();
    }

    public monitorKeyChanged(monitorState: any) {
        this.edit.model.MonitorKey = monitorState.key;
        this.edit.model.FoodMonitor = monitorState.isEnabled;
        this.edit.model.HideMonitor = monitorState.hideMonitor;
    }

    public async save(place: IStoreTapAndGoListItem) {
        const newCheckInStickers = this.edit.newCheckInNfcStickers.map((item) => item.Code);
        const newCheckOutStickers = this.edit.newCheckOutNfcStickers.map((item) => item.Code);

        this.edit.model.CheckInNfcStickerCodes = newCheckInStickers;
        this.edit.model.CheckOutNfcStickerCodes = newCheckOutStickers;

        if (!this.isValidEditModel()) {
            return;
        }

        this.hideMonitorStatuses.set(place.ID, this.edit.model.HideMonitor);

        try {
            this.notificationService.showWaitingMessage();
            await this.orderSettingsService.setPlace(place.ID, this.toServerData(this.edit.model));
            this.$timeout(() => {
                const currentPlace = this.places.find((x) => x.ID === place.ID);
                currentPlace.CheckInNfcStickers = newCheckInStickers;
                currentPlace.CheckOutNfcStickers = newCheckOutStickers;
            }, 100);
            await this.getPlaces();
            this.restoreHideMonitorStatuses();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    public addCheckInCode() {
        if (this.isValidStickers(this.edit.newCheckInNfcStickers)) {
            this.edit.newCheckInNfcStickers.push(this.getStickerItem());
        }
        this.edit.refreshScanAction();
    }

    public async deleteCheckInCode(sticker: IStickerItem) {
        try {
            await this.confirmDeleteSticker();
            if (_.size(this.edit.newCheckInNfcStickers) === 1) {
                const first = _.first(this.edit.newCheckInNfcStickers);
                first.Code = '';
                first.error = null;
                return;
            }
            this.edit.newCheckInNfcStickers = _.reject(this.edit.newCheckInNfcStickers, (item) => item === sticker);
        } catch {
            return;
        }
    }

    public addCheckOutCode() {
        if (this.isValidStickers(this.edit.newCheckOutNfcStickers)) {
            this.edit.newCheckOutNfcStickers.push(this.getStickerItem());
        }
        this.edit.refreshScanAction();
    }

    public async deleteCheckOutCode(sticker: IStickerItem) {
        try {
            await this.confirmDeleteSticker();

            if (_.size(this.edit.newCheckOutNfcStickers) === 1) {
                const first = _.first(this.edit.newCheckOutNfcStickers);
                first.Code = '';
                first.error = null;
            } else {
                this.edit.newCheckOutNfcStickers = _.reject(this.edit.newCheckOutNfcStickers, (item) => item === sticker);
            }
            this.edit.refreshScanAction();
        } catch {
            return;
        }
    }

    public async changeModelCollectedEnabled($event: Event) {
        $event.preventDefault();
        $event.stopPropagation();

        if (this.edit.model.CollectWithoutPincode === true) {
            this.edit.model.CollectWithoutPincode = false;
            return;
        }

        try {
            await this.popupService.confirm({
                cancelClass: 'btn btn-with-icon btn-with-icon--before-close btn-danger',
                cancelTxt: this.$translate.instant('order_settings_collected_dialog_cancel'),
                okClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
                okTxt: this.$translate.instant('order_settings_collected_dialog_ok'),
                classPopup: 'alert--redesign modal360',
                title: this.$translate.instant('order_settings_collected_dialog_header'),
                content: this.$translate.instant('order_settings_collected_dialog_content'),
                closeOnClickOutside: false
            });
        } catch (e) {
            return;
        }

        this.edit.model.CollectWithoutPincode = true;
    }

    public onPaymentMethodChanged() {
        const flows = this.edit.model.ShoppingFlows;
        const actions = this.enumService.ProductScanAction;

        if (!flows.JispGoOrPreOrder.Enabled) {
            this.edit.model.PayNowEnabled = false;
            this.edit.model.FoodMonitor = false;
        }

        const showed = [actions.AddToCart, actions.FlickeringCards, actions.ShowDetails, actions.TapTap].filter((action) => {
            switch (action) {
                case actions.AddToCart:
                    return this.addToCardVisible();
                case actions.FlickeringCards:
                    return this.showCardsVisible();
                case actions.ShowDetails:
                    return this.showDetailsVisible();
                case actions.TapTap:
                    return this.tapTapAllowed();
            }
        });

        if (showed.length === 0) {
            this.edit.model.DefaultProductScanAction = this.defaultScanAction as StoreTapAndGo.DefaultProductScanActionEnum;
        } else {
            if (showed.indexOf(this.defaultScanAction) !== -1) {
                this.edit.model.DefaultProductScanAction = this.defaultScanAction as StoreTapAndGo.DefaultProductScanActionEnum;
            } else {
                this.edit.model.DefaultProductScanAction = actions.ShowDetails as StoreTapAndGo.DefaultProductScanActionEnum;
            }
        }

        this.setShoppingScanMethod();

    }

    public nfcScanningAllowed() {
        const flows = this.edit.model.ShoppingFlows;
        return (flows.JispGoOrPreOrder.Enabled || flows.InStore.Enabled) && !(flows.ClickCollect.Enabled || flows.Delivery.Enabled);
    }

    public barcodeScanningAllowed() {
        const flows = this.edit.model.ShoppingFlows;
        return (flows.JispGoOrPreOrder.Enabled || flows.ClickCollect.Enabled || flows.Delivery.Enabled) && !flows.InStore.Enabled;
    }

    public getShoppingFlows(place: IStoreTapAndGoListItem): string {
        let res = '';
        const  flows = place.ShoppingFlows;
        if (flows) {
            if (flows.JispGoOrPreOrder.Enabled) {
                res += `${this.$translate.instant('store_payment_method_jispgo')}, `;
            }
            if (flows.InStore.Enabled) {
                res += `${this.$translate.instant('buyInStore')}, `;
            }
            if (flows.ClickCollect.Enabled) {
                res += `${this.$translate.instant('click_and_collect')}, `;
            }
            if (flows.Delivery.Enabled) {
                res += this.$translate.instant('delivery');
            }
        }
        return  res.replace(/,\s*$/, '');
    }

    public getPlaceNameWithAddress(place: IStoreTapAndGoListItem) {
        return `${place.Name}, ${place.AddressLine1}`;
    }

    public saveDisabled(): boolean {
        const flows = this.edit.model.ShoppingFlows;
        return !(flows.JispGoOrPreOrder.Enabled || flows.InStore.Enabled || flows.ClickCollect.Enabled || flows.Delivery.Enabled);
    }

    public addToCardVisible(): boolean {
        const flows = this.edit.model.ShoppingFlows;
        return flows.JispGoOrPreOrder.Available && flows.JispGoOrPreOrder.Enabled;
    }

    public showDetailsVisible(place?: IStoreTapAndGoListItem): boolean {
        const flows = place ? place.ShoppingFlows : this.edit.model.ShoppingFlows;
        return (flows.JispGoOrPreOrder.Available && flows.JispGoOrPreOrder.Enabled) ||
               (flows.ClickCollect.Available && flows.ClickCollect.Enabled) ||
               (flows.InStore.Available && flows.InStore.Enabled) ||
               (flows.Delivery.Available && flows.Delivery.Enabled);
    }

    public showCardsVisible(): boolean {
        const flows = this.edit.model.ShoppingFlows;
        return (flows.InStore || flows.ClickCollect) && !flows.JispGoOrPreOrder;
    }

    public tapTapVisible(): boolean {
        const flows = this.edit.model.ShoppingFlows;
        return flows.JispGoOrPreOrder.Available && flows.JispGoOrPreOrder.Enabled;
    }

    public tapTapAllowed(): boolean {
        const flows = this.edit.model.ShoppingFlows;
        return flows.JispGoOrPreOrder.Enabled && !(flows.ClickCollect.Enabled || flows.Delivery.Enabled || flows.InStore.Enabled);
    }

    public tapTapChecked(): boolean {
        return this.edit.model.DefaultProductScanAction === this.enumService.ProductScanAction.TapTap;
    }

    private setShoppingScanMethod() {
        const flows = this.edit.model.ShoppingFlows;
        if (flows.JispGoOrPreOrder.Enabled) {
            this.edit.model.ShoppingScanMethod = EShoppingScanMethod.BARCODE;
        } else if ((flows.ClickCollect.Enabled || flows.Delivery.Enabled) && !(flows.JispGoOrPreOrder.Enabled || flows.InStore.Enabled)) {
            this.edit.model.ShoppingScanMethod = EShoppingScanMethod.BARCODE;
        } else if (flows.InStore.Enabled) {
            this.edit.model.ShoppingScanMethod = EShoppingScanMethod.NFC;
        } else {
            this.edit.model.ShoppingScanMethod = EShoppingScanMethod.BARCODE;
        }
    }

    private confirmDeleteSticker(): Promise<void> {
        return this.popupService.confirm({
            cancelClass: 'btn btn-with-icon btn-with-icon--before-close btn-danger',
            cancelTxt: this.$translate.instant('delete_sticker_dialog_content_cancel'),
            okClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
            okTxt: this.$translate.instant('delete_sticker_dialog_content_ok'),
            classPopup: 'alert--redesign modal360',
            title: this.$translate.instant('delete_sticker_dialog_title'),
            content: this.$translate.instant('delete_sticker_dialog_content')
        });
    }

    private isValidEditModel() {
        const i = this.edit;
        i.error.clean();

        const flows = i.model.ShoppingFlows;

        if (flows.JispGoOrPreOrder.Enabled && i.model.ShoppingScanMethod === EShoppingScanMethod.NFC &&
          !i.model.PayNowEnabled && i.newCheckOutNfcStickers.filter((item) => item.Code).length === 0) {
            this.notificationService.showErrorMessage(this.$translate.instant('checkout_stickers_pay_now_error'));
            return false;
        }

        if (!flows.JispGoOrPreOrder.Enabled) {
            return i.error.isEmpty();
        }

        if (i.model.BagCheckSettings.Enabled && !i.model.BagCheckSettings.Chance) {
            i.error.bagCheckSettingsChance = this.$translate.instant('required_field');
        }

        const checkInStickerAreValid = _.all(i.newCheckInNfcStickers, (s) => _.isEmpty(s.Code))
            || this.isValidStickers(i.newCheckInNfcStickers);

        const checkOutStickerAreValid = flows.JispGoOrPreOrder.Enabled && i.model.ShoppingScanMethod === EShoppingScanMethod.NFC && !i.model.PayNowEnabled
          ? this.isValidStickers(i.newCheckOutNfcStickers)
          : _.all(i.newCheckOutNfcStickers, (s) => _.isEmpty(s.Code)) || this.isValidStickers(i.newCheckOutNfcStickers);

        let validStickers = checkInStickerAreValid && checkOutStickerAreValid;

        const inNfcStickerCodes = _.reject(i.newCheckInNfcStickers, (item) => _.isEmpty(item.Code));
        const outNfcStickerCodes = _.reject(i.newCheckOutNfcStickers, (item) => _.isEmpty(item.Code));

        if (!_.isEmpty(inNfcStickerCodes) && !_.isEmpty(outNfcStickerCodes)) {
            _.forEach(inNfcStickerCodes, (inSticker) => {
                const outSticker = _.findWhere(outNfcStickerCodes, { Code: inSticker.Code });
                if (!_.isUndefined(outSticker)) {
                    outSticker.error = this.$translate.instant('this_code_is_already_used');
                    inSticker.error = this.$translate.instant('this_code_is_already_used');
                    validStickers = false;
                }
            });
        }
        return validStickers && i.error.isEmpty();
    }

    private isValidStickers(stickers: IStickerItem[]) {
        _.forEach(stickers, (item) => {
            item.error = null;
            item.Code = item.Code ? item.Code.trim() : '';
            if (_.isEmpty(item.Code)) {
                item.error = this.$translate.instant('required_field');
                return;
            }

            if (_.size(item.Code) > this.maxLength) {
                item.error = this.$translate.instant('sticker_code_too_long');
                return;
            }

            if (!(new RegExp(STICKER_PATTERN).test(item.Code))) {
                item.error = this.$translate.instant('invalid_field_format');
                return;
            }

            const couple = _.filter(stickers, (i) => !_.isEmpty(i.Code) && i.Code.toLowerCase() === item.Code.toLowerCase());
            if (_.size(couple) > 1) {
                _.forEach(couple, (p) => p.error = this.$translate.instant('sticker_code_already_exists'));
            }
        });

        return _.all(stickers, (item) => _.isEmpty(item.error));
    }

    private async getPlaces() {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const pagingResult = await this.orderSettingsService.getPlaces({});
            this.places = this.toClientData(pagingResult.Items as IStoreTapAndGoListItem[]);
            this.isPlacesAny = pagingResult.Total > 0;
            this.notificationService.clearAll();

        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
        this.edit.isOpenEdit = false;
    }

    private toClientData(places: IStoreTapAndGoListItem[]) {
        const data = angular.copy(places);
        _.forEach(data, (place: IStoreTapAndGoListItem) => {
            place.RandomCheckChance = place.RandomCheckChance ? parseFloat((place.RandomCheckChance * 100).toFixed(1)) : null;
        });
        return data;
    }

    private toServerData(place: IStoreTapAndGo) {
        const data = angular.copy(place);
        data.BagCheckSettings.Chance = data.BagCheckSettings.Chance ? data.BagCheckSettings.Chance / 100 : null;
        return data;
    }

    private getStickerItem(item?: string): IStickerItem {
        return {
            ID: 0,
            Code: item ? item : null,
            error: null
        };
    }

    private setCheckInAndCheckOutTitles() {
        this.checkInStickersTitle = this.$translate.instant('check_in_stickers');
        this.checkOutStickersTitle = this.$translate.instant('check_out_stickers');
    }

    private restoreHideMonitorStatuses() {
        this.places.forEach((place) => {
            if (this.hideMonitorStatuses.has(place.ID) && place.MonitorKey) {
                place.HideMonitor = this.hideMonitorStatuses.get(place.ID);
            }
        });
    }
}

angular.module('naut').component('orderSettingsLocations', {
    template: require('./order-settings-locations.component.html'),
    controller: OrderSettingsLocations,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/tapAndGo/components/order-settings-locations.component.ts